var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2092_57371)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0556641,
    y: 0.592773,
    width: 106,
    height: 71,
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0407 13.0728L30.54 55.5735L34.0756 59.109L76.5762 16.6084L73.0407 13.0728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3055 34.8778H72.3055V17.3428H54.7705V12.3428H77.3055V34.8778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5557 36.3428C33.3157 36.3428 29.0557 32.0828 29.0557 26.8428C29.0557 21.6028 33.3157 17.3428 38.5557 17.3428C43.7957 17.3428 48.0557 21.6028 48.0557 26.8428C48.0557 32.0828 43.7957 36.3428 38.5557 36.3428ZM38.5557 22.3428C36.0757 22.3428 34.0557 24.3628 34.0557 26.8428C34.0557 29.3228 36.0757 31.3428 38.5557 31.3428C41.0357 31.3428 43.0557 29.3228 43.0557 26.8428C43.0557 24.3628 41.0357 22.3428 38.5557 22.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5557 60.8428C57.3157 60.8428 53.0557 56.5828 53.0557 51.3428C53.0557 46.1028 57.3157 41.8428 62.5557 41.8428C67.7957 41.8428 72.0557 46.1028 72.0557 51.3428C72.0557 56.5828 67.7957 60.8428 62.5557 60.8428ZM62.5557 46.8428C60.0757 46.8428 58.0557 48.8628 58.0557 51.3428C58.0557 53.8228 60.0757 55.8428 62.5557 55.8428C65.0357 55.8428 67.0557 53.8228 67.0557 51.3428C67.0557 48.8628 65.0357 46.8428 62.5557 46.8428Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2092_57371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 71,
    fill: "white",
    transform: "translate(0.0556641 0.592773)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyg);
export default __webpack_public_path__ + "static/media/HYG.1f4ff0e5c044f19c00dedb5d66506bca.svg";
export { ForwardRef as ReactComponent };